// Shared brain background used on host and player screens.
export const BRAIN_BACKGROUND_URL =
  "https://firebasestorage.googleapis.com/v0/b/bobquiz-272a7.firebasestorage.app/o/media%2FBrainbackground.png?alt=media";

export function brainBackgroundCSS(
  url = BRAIN_BACKGROUND_URL,
  { gradient = null, fallback = "#223b4c" } = {}
) {
  if (!url) return fallback;
  if (gradient) {
    return `linear-gradient(${gradient}), url(${url}) center center / cover no-repeat`;
  }
  return `url(${url}) center center / cover no-repeat`;
}

export function brainScreenStyle(options = {}) {
  return {
    minHeight: "100vh",
    width: "100vw",
    background: brainBackgroundCSS(options.url, options),
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  };
}

/** Shared title style for player join wizard steps (team name, selfie, etc.). */
export const wizardTitleStyle = {
  fontSize: "2em",
  fontWeight: 900,
  fontFamily: "'QuizPlayerMontserrat', 'Montserrat', 'Arial Black', Arial, sans-serif",
  marginBottom: 18,
  color: "#fff",
  textShadow: "0 0 8px #000, 0 2px 12px #000",
  lineHeight: 1.25,
  maxWidth: 340,
};
